<template>
  <div>
    <el-time-picker
      ref="timePicker"
      v-model="value"
      v-bind="trimAttrs($attrs)"
      :is-range="isIntervalSelection"
      :arrow-control="hasArrowsInPanel"
      :align="timePickerTextAlign"
      :picker-options="timePickerOptions"
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    >
      <slot />
    </el-time-picker>
  </div>
</template>

<script>
import { TimePicker } from 'element-ui';
export default {
  name: 'JskTimePicker',
  components: {
    ElTimePicker: TimePicker
  },
  inheritAttrs: false,
  model: {
    prop: 'vModel',
    event: 'change'
  },
  props: {
    vModel: [Date, String, Array],
    timePickerOptions: {
      type: Object
    },
    isIntervalSelection: {
      type: Boolean,
      default: false
    },
    hasArrowsInPanel: {
      type: Boolean,
      default: false
    },
    timePickerTextAlign: {
      type: String,
      default: 'left'
    }
  },
  data: function() {
    return {
      value: ''
    };
  },
  watch: {
    value: function() {
      this.$emit('change', this.value);
      this.$nextTick(() => {
        if (this.value !== this.vModel) {
          this.value = this.vModel;
        }
      });
    },
    vModel: function() {
      this.value = this.vModel;
    }
  },
  created: function() {
    this.value = this.vModel;
  },
  methods: {
    trimAttrs: function(attrs) {
      Object.keys(attrs).forEach((key) => {
        let prefixes = ['is-', 'has-', 'time-picker-'];
        prefixes.forEach((prefix) => {
          if (key.substr(0, prefix.length) === prefix) {
            attrs[key.substr(prefix.length)] = attrs[key];
          }
        })
      })
      return attrs;
    },
    focus: function() {
      this.$refs.timePicker.focus();
    }
  }
}
</script>
<style lang="scss" src="../../theme/time-picker.scss"></style>
